module.exports = __webpack_public_path__ + "static/media/hard.292ff675.jpg";